/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const radioradio: CommunityData = {
  code: "radioradio",
  inviteCode: "radioradio",
  name: "RadioRadio",
  thumbnail: "/assets/customizations/radioRadio/thumbnail.png",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/radioradio`,
  socials: {},
  styles: {
    global: {
      counterColor: "#FFFFFF",
      bgDesktop: "/assets/customizations/radioRadio/bg.png",
      bgMobile: "/assets/customizations/radioRadio/bg.png",
      alternativeLogo: {
        src: "/assets/customizations/radioRadio/logo.png",
        styles: "w-[148px]",
      },
      logo: {
        src: "/assets/customizations/radioRadio/logo-2.png",
        styles: "w-[148px] mt-[-30px]",
      },
      contentBoxShadow: "border border-[#FFFFFF] rounded-[8px]",
      bgColor: "#000000",
      asideBg: "#000000",
      asideStyles: "border border-[#FFFFFF]",
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      contentBg: "#000000",
      mainFont: "font-['NeueMontreal']",
      customPrimaryButton: "",
      primaryButton:
        "flex justify-center text-nowrap items-center !h-[43px] bg-[#000000] border rounded-full border-[#5B5B5B] !font-normal text-[#D9D9D9] uppercase text-[18px] px-[22px] font-['NeueMontreal']",
    },
    navigation: {
      sideBarSeparator: "",
      iconsColor: "#EFFD71",
      separator: "border-t-[#D9D9D9] border-t",
      item: "text-[#D9D9D9] text-[20px] leading-[14px] h-[40px] flex sm:justify-start justify-center items-center",
      itemSelected: "custom-prefix",
    },
    communityLanding: {
      emptyOrLoadingState: "",
      titles: "text-[#D9D9D9] text-[24px] leading-[24px] pb-2",
      announcements: {
        lg: {
          title: "text-[#D9D9D9] text-[16px] leading-[16px]",
          subtitle:
            "text-[#D9D9D9] text-[14px] leading-[14px] !bg-[#000000] h-[24px] flex items-center",
        },
        sm: {
          title: "text-[#D9D9D9] text-[16px] leading-[16px]",
          subtitle:
            "text-[#D9D9D9] text-[14px] leading-[14px] !bg-[#000000] h-[24px] flex items-center",
        },
      },
      event: {
        title: "text-[20px] text-[#D9D9D9] one-line-truncate",
        subtitle: "text-[14px] text-[#D9D9D9] leading-[14px]",
      },
      shop: {
        title: "text-[20px] text-[#D9D9D9]",
        text: "text-[14px] text-[#D9D9D9] leading-[16.8px]",
        customShopImage: "https://media.werz.at/community-assets/radioradio/shop-image.jpg",
      },
    },
    announcements: {
      created: "text-[14px] text-[#D9D9D9] leading-[16.8px]",
      emptyOrLoadingState: "text-[20px] text-[#D9D9D9] leading-[20px] mb-[500px]",
      container: "mb-16 sm:p-11 p-7 sm:space-y-[38px] space-y-[33px]",
      header: "text-[#D9D9D9] text-[24px] leading-[24px] pb-2",
      title: "text-[20px] text-[#D9D9D9]",
      description: "text-[14px] text-[#D9D9D9] leading-[16.8px]",
    },
    announcement: {
      created: "text-[14px] text-[#D9D9D9] leading-[16.8px]",
      emptyOrLoadingState: "text-[20px] leading-[20px] mb-[500px] text-[#D9D9D9]",
      container: "sm:p-10 p-7 pb-8 space-y-[23px]",
      title: "text-[20px] text-[#D9D9D9]",
      description: "text-[14px] text-[#D9D9D9] leading-[16.8px]",
      commentIconColor: "#D9D9D9",
      likeIconColor: "#D9D9D9",
      likeCount: "text-[14px] text-[#D9D9D9]",
      commentCount: "text-[14px] text-[#D9D9D9]",
    },
    events: {
      sectionHeader: "text-[24px] text-[#D9D9D9]",
      container: "mb-16 sm:p-11 p-7 sm:pb-8 sm:space-y-[57px] space-y-[25px]",
      header: "text-[#D9D9D9] text-[24px] leading-[24px] pb-2",
      title: "text-[20px] text-[#D9D9D9] one-line-truncate",
      emptyOrLoadingState: "text-[20px] leading-[20px] mb-[500px] text-[#D9D9D9]",
      duration: "text-[12px] text-[#FDFAF1] leading-[12px] mb-4",
      address: "text-[12px] text-[#FDFAF1] leading-[12px]",
      separator: "mb-8 mt-2 border-b border-b-[1px] border-[#FFFFFF]",
    },
    event: {
      blockContainer: "flex flex-col gap-3",
      container: "flex flex-col sm:p-11 p-6",
      emptyOrLoadingState: "text-[20px] leading-[20px] mb-[500px] text-[#D9D9D9]",
      header: "text-[24px] text-[#D9D9D9] leading-[28.8px] sm:pb-0 pb-[24px]",
      sectionSubtitle: "text-[16px] text-[#D9D9D9] leading-[19.2px]",
      sectionTitle: "text-[24px] text-[#D9D9D9] leading-[18.8px]",
      text: "text-[14px] text-[#D9D9D9] leading-[16.8px]",
      separator: "sm:my-8 my-6 border-b border-b-[1px] border-[#FFFFFF]",
      map: {
        pin: "",
        border: "mb-2",
        pinColor: "#000000",
        strokeColor: "",
      },
    },
    eventTickets: {
      container: "flex flex-col sm:p-11 p-6 sm:mt-auto mt-[-8px]",
      event: {
        title: "text-[24px] text-[#D9D9D9] leading-[28.8px] mt-[8px]",
        subtitle: "text-[16px] text-[#D9D9D9] leading-[19.2px]",
      },
      ticket: {
        title: "text-[24px] text-[#D9D9D9] one-line-truncate",
        description: "text-[16px] leading-[30px] text-[#D9D9D9]",
        text: "text-[14px] text-[#FDFAF1] leading-[16.8px] opacity-[80%]",
        price: "text-[24px] uppercase text-[#D9D9D9]",
        counterContainer: "border !border-[#FFFFFF]",
        quantity: "text-[26px] text-[#D9D9D9] mt-[4px]",
      },
      separator: "sm:my-8 my-6 border-b-[#FDFAF1] border-b-[1px] border-black",
    },
    linktree: {
      bgMobile: "/assets/customizations/radioRadio/bg.png",
      bgDesktop: "/assets/customizations/radioRadio/bg.png",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative bg-[#000000] p-[64px]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] border-[#FFFFFF]",
        name: "text-[35px] mt-2 text-[#FFFFFF] font-['NeueMontreal']",
        location: "text-[16px] text-[#828282] font-['NeueMontreal'] mb-2",
        description:
          "text-[15px] leading-[17px] text-[#FFFFFF] text-center mb-4 font-['NeueMontreal']",
        socialMediaIconColor: "#FFFFFF",
        button:
          "flex justify-center items-center h-[55px] bg-[#000000] text-[#FFFFFF] text-[18px] px-[24px] border-[2px] border-[#5B5B5B] font-['NeueMontreal'] rounded-full cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] bg-[#000000] font-['NeueMontreal'] text-[#FFFFFF] text-[16px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#FFFFFF] rounded-[8px]",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] rounded-[8px] bg-[#000000] flex justify-between border border-[#FFFFFF] flex flex-col justify-center items-center p-[34px] mb-[32px]",
          title: "text-[#FFFFFF] text-[14px] mb-1 font-['NeueMontreal']",
          text: "text-[11px] text-[#828282] font-['NeueMontreal']",
          button:
            "flex justify-center w-[108px] items-center mt-4 h-[43px] bg-[#000000] text-[#FFFFFF] text-[16px] border-[2px] border-[#5B5B5B] font-['NeueMontreal'] rounded-full cursor-pointer",
        },
        header: "text-[20px] mb-[10px] text-center text-[#FFFFFF] font-['NeueMontreal']",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] bg-[#000000] w-[95vw] rounded-[8px] flex justify-between border border-[#FFFFFF]",
          duration: "text-[12px] text-[#828282] font-['NeueMontreal']",
          name: "text-[16px] leading-[16px] text-[#FFFFFF] one-line-truncate sm:w-[390px] w-[65vw] font-['NeueMontreal']",
          plusIconColor: "#FFFFFF",
          media: "border border-[#FFFFFF] overflow-hidden rounded-[8px] m-2",
        },
        event: {
          container:
            "border border-[#FFFFFF] rounded-[8px] bg-[#000000] overflow-hidden sm:w-[500px] w-[95vw]",
          name: "text-[20px] mb-1 text-[#FFFFFF] font-['NeueMontreal'] one-line-truncate sm:w-[370px] w-[60vw] ",
          startDate:
            "w-[64px] h-[64px] rounded-[6px] bg-[#FFFFFF] text-[#000000] flex flex-col justify-center items-center gap-1 font-bold font-['NeueMontreal']",
          duration: "text-[12px] text-[#828282] font-['NeueMontreal']",
          location: "text-[12px] text-[#828282] font-['NeueMontreal']",
          button:
            "flex justify-center w-[108px] items-center mt-3 h-[38px] bg-[#000000] text-[#FFFFFF] text-[16px] border-[2px] border-[#5B5B5B] font-['NeueMontreal'] rounded-full cursor-pointer",
          product: {
            container: "h-[68px] border-t px-4 py-3 flex justify-between",
            name: "text-[16px] text-[#FFFFFF] font-['NeueMontreal'] one-line-truncate sm:w-[390px] w-[65vw]",
            price: "uppercase text-[#828282] text-[12px] font-['NeueMontreal']",
            status: "text-[#FFFFFF] text-[16px] font-['NeueMontreal']",
            link: "text-[#828282] text-[11px] font-mono font-['NeueMontreal']",
            button:
              "flex justify-center w-[60px] items-center h-[38px] bg-[#000000] text-[#FFFFFF] text-[16px] border-[2px] border-[#5B5B5B] font-['NeueMontreal'] rounded-full cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#FFFFFF] text-[14px] font-['NeueMontreal'] text-center mt-4 cursor-pointer mb-[32px]",
      },
      news: {
        loadingState:
          "mb-[32px] bg-[#000000] font-['NeueMontreal'] text-[#FFFFFF] text-[16px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#FFFFFF] rounded-[8px]",
        header: "text-[20px] mb-[10px] text-center text-[#FFFFFF] font-['NeueMontreal']",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer bg-[#000000] sm:w-[500px] w-[95vw] rounded-[8px] flex justify-between border border-[#FFFFFF]",
          name: "text-[16px] leading-[16px] text-[#FFFFFF] one-line-truncate sm:w-[390px] w-[65vw] font-['NeueMontreal']",
          triangleIconColor: "#FFFFFF",
          created: "text-[#828282] text-[12px] font-['NeueMontreal']",
          media: "border border-[#FFFFFF] overflow-hidden rounded-[8px] m-2",
        },
        seeAllNews:
          "text-[#FFFFFF] text-[14px] font-['NeueMontreal'] text-center mt-4 cursor-pointer mb-[32px]",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] bg-[#000000] font-['NeueMontreal'] text-[#FFFFFF] text-[16px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#FFFFFF] rounded-[8px]",
        header: "text-[20px] mb-[10px] text-center text-[#FFFFFF] font-['NeueMontreal']",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] bg-[#000000] w-[95vw] rounded-[8px] flex justify-between border border-[#FFFFFF]",
          name: "text-[15px] text-[#FFFFFF] font-['NeueMontreal']",
          triangleIconColor: "#FFFFFF",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full border border-[#FFFFFF] object-cover",
        },
      },
      footer: {
        WERZlogoColor: "#FFFFFF",
        text: "uppercase font-mono text-[11px] font-bold text-[#FFFFFF]",
      },
    },
  },
}

export default radioradio
